import { FC, useContext } from 'react';
import { Menu } from '@chakra-ui/react';

import {
  ApplicationContext,
  DocumentDetailsViewActionContext,
} from '../Layout.component';

export const LixiShowXmlMenuItem: FC = () => {
  const { actionContexts } = useContext(ApplicationContext);
  const {
    action: { text, key },
  } = useContext(DocumentDetailsViewActionContext);

  const { modal } = actionContexts[key];

  return (
    <Menu.Item onClick={modal.onOpen} value="lixi-show-xml">
      {text}
    </Menu.Item>
  );
};
